<script lang="ts">
    import {removeCharacters} from '$lib/utils/removeCharacters';
    import AudioBrowseWord from '$lib/components/browse/WordCard/AudioBrowseWord.svelte';
    import {Noun} from '$lib/classes/data/word';
    import type {Translation} from '$lib/classes/data/_primitives';
    import type {FilterSettings} from '$lib/stores/filterSettings';
    import type {CurrentWord} from '$lib/stores/currentWord';
    import {type Device, DeviceType} from '$lib/stores/ui/device';

    export let currentWord: CurrentWord
    // TODO refactor !! Don't pass split array as 'word'
    export let word: string[]
    export let translations: Translation[]
    export let filterSettings: FilterSettings
    export let device: Device

    function handleEnClick(translation: string) {
        if ($device === DeviceType.Mobile) return
        $filterSettings.search = removeCharacters(translation)
    }
</script>

<div id="translation">

    <div id="deu" class="trans">
        {#each word as w, index}
            <div>
                {#if index === 0 && $currentWord instanceof Noun}
                    <span class="article">{`${$currentWord.genus.article} `}</span>
                {/if}
                <span class="emphasize">
                {w}
            </span>
            </div>
        {/each}
    </div>

    <div id="en" class="trans">
        {#each translations as translation}
            <!-- svelte-ignore a11y-click-events-have-key-events  a11y-no-static-element-interactions -->
            <div class="translation"
                 on:click={() => handleEnClick(translation)}>
                {translation}
            </div>
        {/each}
    </div>

    {#key $currentWord}
        <AudioBrowseWord
                currentWord={currentWord}
        />
    {/key}

</div>

<style>
    #translation {
        /*min-height: 3rem;*/
        position: relative;
        width: 100%;
        margin: auto 0;
        display: flex;
        justify-content: center;
        font-size: 1.1rem;
        line-height: 1.6;
        transition: var(--transition);
        user-select: none;
        /*border: 1px solid peachpuff;*/
    }

    .translation {
        cursor: pointer;
        border-radius: var(--border-radius);
        padding: 0 6px;
    }

    .translation:hover {
        background: var(--color-lighter);
    }

    .trans {
        width: 100%;
        /*border: 1px solid orange;*/
    }

    #deu {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        padding-right: 1rem;
        border-right: 2px solid var(--color-dark);
    }

    #en {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 1rem;
    }

    @media (max-width: 1000px) {
        #translation {
            margin: 0;
            font-size: 1.05rem;
        }

        #deu {
            text-align: right;
            line-height: 1.4;
        }
    }


</style>